import { render, staticRenderFns } from "./Landlords.vue?vue&type=template&id=0f25404d&scoped=true"
import script from "./Landlords.vue?vue&type=script&lang=js"
export * from "./Landlords.vue?vue&type=script&lang=js"
import style0 from "./Landlords.vue?vue&type=style&index=0&id=0f25404d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f25404d",
  null
  
)

export default component.exports